// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"7f995539","245":"d0ddfdfb"}[chunkId] + ".chunk.js";
};